import React from 'react';
import './Navigation.css';

function Navigation({ user, onLogout }) {
  return (
    <nav className="navigation">
      <div className="nav-container">
        <div className="nav-brand">
          <span className="brand-icon">📧</span>
          <h2>Gmail Organizer</h2>
        </div>
        
        <div className="nav-right">
          {user && (
            <div className="user-info">
              {user.profilePhoto && (
                <img src={user.profilePhoto} alt={user.displayName} className="user-avatar" />
              )}
              <div className="user-details">
                <p className="user-name">{user.displayName}</p>
                <p className="user-email">{user.email}</p>
              </div>
            </div>
          )}
          <button className="logout-btn" onClick={onLogout}>
            Logout
          </button>
        </div>
      </div>
    </nav>
  );
}

export default Navigation;
